import React from 'react';
import { Grid, CircularProgress } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import api from '../../services/api';
import { UbabyStatus } from './components/UbabyStatus';
import { SearchUbaby } from './components/SearchUbaby';

export function UbabyDetails() {
  const { phoneNumber, month } = useParams();
  const { data: ubaby, isLoading } = useQuery(
    ['user', phoneNumber, month],
    async () => {
      const { data } = await api.get(`/ubabies/${month}/find/${phoneNumber}`);
      return data;
    },
    {
      enabled: !!phoneNumber && !!month,
      retry: false,
    }
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SearchUbaby />
      </Grid>
      <Grid item xs={12}>
        {isLoading && phoneNumber && month ? (
          <Grid container justifyContent='center' alignItems='center' style={{ height: '100vh' }}>
            <CircularProgress />
          </Grid>
        ) : (
          ubaby && <UbabyStatus ubabyData={ubaby} />
        )}
      </Grid>
    </Grid>
  );
}
